<template>
  <div class="sk-reset-page">
    <div class="sk-topbar">
      <router-link to="/login" class="sk-logo">
        <svg viewBox="0 0 32 32" fill="none">
          <path d="M16 3L28 9V18C28 23.5 22.8 28.3 16 30C9.2 28.3 4 23.5 4 18V9L16 3Z" fill="#F5841F" opacity="0.2"/>
          <path d="M16 3L28 9V18C28 23.5 22.8 28.3 16 30C9.2 28.3 4 23.5 4 18V9L16 3Z" stroke="#F5841F" stroke-width="1.5" fill="none"/>
          <path d="M11 16l3.5 3.5L21 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="sk-logo-text">SentryKit</span>
      </router-link>
    </div>

    <div class="sk-main">
      <div class="sk-card">
        <div class="sk-card-header">
          <h2>Verify email</h2>
          <p v-if="working">Confirming your email address…</p>
          <p v-else-if="!token || !email">This link is missing required parameters.</p>
        </div>

        <div v-if="error" class="sk-error-msg">
          <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor"><circle cx="12" cy="12" r="10" stroke-width="2"/><path stroke-width="2" d="M12 8v4m0 4h.01"/></svg>
          {{ error }}
        </div>

        <div v-if="message" class="sk-success-msg">
          <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
          {{ message }}
        </div>

        <div class="sk-login-link" v-if="!working">
          <router-link to="/login">Log in</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './styles/signup-flow.css'

export default {
  data: function () {
    return {
      working: true,
      error: '',
      message: ''
    }
  },
  computed: {
    token: function () {
      var t = this.$route.query.token
      return t != null && String(t).trim() !== '' ? String(t).trim() : ''
    },
    email: function () {
      var e = this.$route.query.email
      return e != null && String(e).trim() !== '' ? String(e).trim() : ''
    }
  },
  created: function () {
    if (!this.token || !this.email) {
      this.working = false
      this.error = 'Invalid verification link. Check the link in your email or request a new one.'
      return
    }
    this.$http.get('/api/identity/verify-email', {
      params: { token: this.token, email: this.email }
    }).then(
      (response) => {
        this.working = false
        var body = response.body
        var msg = (body && (body.message || body.msg)) || 'Your email has been verified.'
        this.message = msg
        setTimeout(() => { this.$router.push('/login') }, 2500)
      },
      (response) => {
        this.working = false
        var body = response.body
        var m = body && typeof body === 'object' ? body.message : null
        this.error = m || (typeof body === 'string' ? body : '') || 'Verification failed. The link may have expired.'
      }
    )
  }
}
</script>

<style scoped>
.sk-reset-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'DM Sans', -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
}

.sk-success-msg {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 13px;
  color: #166534;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.sk-login-link {
  margin-top: 1rem;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// VerifyEmailPage.vue?2f8afaa2